<template>
  <domain-whois :domainid="domainid" />
</template>

<script>
import DomainWhois from '@/components/Domains/DomainWhois'

export default {
  name: 'DomainWhoisView',
  components: {
    DomainWhois
  },
  props: {
    domainid: {
      type: [String, Number],
      required: true,
    }
  },

}
</script>
